import { useCallback } from 'react'

import useAvailabilityPrefetch from '@/components/integration/nylas/scheduler/hooks/useAvailabilityPrefetch'
import {
  AvailabilityFilter,
  EVERY_ADVISER_AVAILABILITY_FILTER,
  SchedulerAvailabilitySource,
  SchedulerOwningEntityType,
} from '@/components/integration/nylas/scheduler/types'
import availabilityService from '@/lib/services/availabilityService'

export default function usePrefetchMonthAvailability(
  type: SchedulerOwningEntityType,
  owningEntityId: number | string,
  availabilityFilter: AvailabilityFilter = EVERY_ADVISER_AVAILABILITY_FILTER,
  availabilitySource?: SchedulerAvailabilitySource,
) {
  const prefetch = useAvailabilityPrefetch(
    type,
    owningEntityId,
    availabilityFilter,
    availabilitySource,
  )

  return useCallback(
    (month: Date) => {
      const { start, end } = availabilityService.getMonthDateRange(month)
      return prefetch(start, end)
    },
    [prefetch],
  )
}
